export function resetScroll() {
  if (typeof document !== "undefined") {
    const mainAdminAppElem = document.querySelector("#AppFrameMain");
    if (mainAdminAppElem) {
      mainAdminAppElem.scrollTop = 0;
    }
  }
}
